import { render } from "./contact.vue?vue&type=template&id=3612baef&scoped=true"
import script from "./contact.vue?vue&type=script&lang=ts"
export * from "./contact.vue?vue&type=script&lang=ts"

import "./contact.vue?vue&type=style&index=0&id=3612baef&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3612baef"

export default script